/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScannerRuleList {
    getFixupPrototypeFunction() { return ScannerRuleList.fixupPrototype; }

    static newInstance(model: Partial<ScannerRuleList>): ScannerRuleList {
        let obj = Object.assign(new ScannerRuleList(), model);
        ScannerRuleList.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScannerRuleList>): ScannerRuleList {
        if (!model) return null;
        return ScannerRuleList.newInstance(<ScannerRuleList> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScannerRuleList) {
        if (!obj) return;

        models.ScannerRuleList.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScannerRuleList): boolean {
        Object.setPrototypeOf(obj, ScannerRuleList.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.rules) {
            for (let val of this.rules) {
                models.ScannerListResponseDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * The list of scanner rules.
     */
    rules: Array<models.ScannerListResponseDetails>;

}
